// chartColors.ts
const chartColors = [
  "#FF8080", // Medium red
  "#FFFF66", // Medium yellow
  "#FF9933", // Medium orange
  "#99FF99", // Medium green
  "#66CCFF", // Medium blue
  "#CC99FF", // Medium purple
  "#FF99CC", // Medium pink
  "#FFD699", // Medium beige
  "#B2D8A3", // Medium lime green
  "#FF99E6", // Medium magenta
  //   "#FFB380", // Medium peach
  "#80D4FF", // Medium sky blue
  //   "#FFA07A", // Medium coral
  "#98FB98", // Medium pale green
  "#BA55D3", // Medium orchid
  "#CD5C5C", // Medium salmon
  "#F0E68C", // Medium khaki
  "#AFEEEE", // Medium pale turquoise
  "#DDA0DD", // Medium plum
  "#87CEFA", // Medium light sky blue
];

export default chartColors;
